// View --->
function MakeViewActive(button) {
  const spans = button.querySelectorAll('.cells_dd2 span');
  let currentIndex = -1;
  spans.forEach((span, i) => {
    if (span.classList.contains('filled')) currentIndex = i;
  });
  if (currentIndex === spans.length - 1) {
    spans.forEach((span) => span.classList.remove('filled'));
    spans[0].classList.add('filled');
  } else {
    spans[currentIndex + 1].classList.add('filled');
  }
}

// Model --->
function MakeModelActive(element) {
  element.classList.toggle('active_dd1');
}
